export const actionTypes = {
  GET_APP_INFO: 'GET_APP_INFO',
  GET_APP_INFO_SUCCESS: 'GET_APP_INFO_SUCCESS',
  GET_APP_INFO_FAIL: 'GET_APP_INFO_FAIL',

  UPDATE_APP_INFO: 'UPDATE_APP_INFO',
  UPDATE_APP_INFO_SUCCESS: 'UPDATE_APP_INFO_SUCCESS',
  UPDATE_APP_INFO_FAIL: 'UPDATE_APP_INFO_FAIL',

  GET_LIST_CATEGORY: 'GET_LIST_CATEGORY',
  GET_LIST_CATEGORY_SUCCESS: 'GET_LIST_CATEGORY_SUCCESS',
  GET_LIST_CATEGORY_FAIL: 'GET_LIST_CATEGORY_FAIL',

  SUBMIT_APP: 'SUBMIT_APP',
  SUBMIT_APP_SUCCESS: 'SUBMIT_APP_SUCCESS',
  SUBMIT_APP_FAIL: 'SUBMIT_APP_FAIL',

  TOGGLE_APP_INFO_MODAL: 'TOGGLE_APP_INFO_MODAL',
};

export const actions = {
  getAppInfo: () => ({
    type: actionTypes.GET_APP_INFO,
  }),
  getAppInfoSuccess: (data: unknown) => ({
    type: actionTypes.GET_APP_INFO_SUCCESS,
    payload: data,
  }),
  getAppInfoFail: (err: unknown) => ({
    type: actionTypes.GET_APP_INFO_FAIL,
    payload: err,
  }),

  updateAppInfo: () => ({
    type: actionTypes.UPDATE_APP_INFO,
  }),
  updateAppInfoSuccess: (data: unknown) => ({
    type: actionTypes.UPDATE_APP_INFO_SUCCESS,
    payload: data,
  }),
  updateAppInfoFail: (err: unknown) => ({
    type: actionTypes.UPDATE_APP_INFO_FAIL,
    payload: err,
  }),

  getListCategory: () => ({
    type: actionTypes.GET_LIST_CATEGORY,
  }),
  getListCategorySuccess: (data: unknown) => ({
    type: actionTypes.GET_LIST_CATEGORY_SUCCESS,
    payload: data,
  }),
  getListCategoryFail: (err: unknown) => ({
    type: actionTypes.GET_LIST_CATEGORY_FAIL,
    payload: err,
  }),

  submitApp: () => ({
    type: actionTypes.SUBMIT_APP,
  }),
  submitAppSuccess: (data?: unknown) => ({
    type: actionTypes.SUBMIT_APP_SUCCESS,
    payload: data,
  }),
  submitAppFail: (err: unknown) => ({
    type: actionTypes.SUBMIT_APP_FAIL,
    payload: err,
  }),

  toggleAppInfo: (isOpen: boolean = false) => ({
    type: actionTypes.TOGGLE_APP_INFO_MODAL,
    payload: isOpen
  }),
};
